/* Twink — Sample A theme JS */
(function(){
  "use strict";

  // Nav condense on scroll
  var nav = document.getElementById("nav");
  function onScroll(){ if(nav) nav.classList.toggle("scrolled", window.scrollY > 40); }
  onScroll(); window.addEventListener("scroll", onScroll, { passive:true });

  // Mobile drawer
  var drawer = document.getElementById("drawer");
  var toggle = document.getElementById("menuToggle");
  if(toggle && drawer){
    toggle.addEventListener("click", function(){ drawer.classList.add("open"); });
    drawer.querySelectorAll("[data-close]").forEach(function(b){
      b.addEventListener("click", function(){ drawer.classList.remove("open"); });
    });
    drawer.querySelectorAll(".acc-btn[aria-expanded]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!open));
        panel.style.maxHeight = open ? null : panel.scrollHeight + "px";
      });
    });
  }

  // Reveal on scroll
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold:.12, rootMargin:"0px 0px -8% 0px" });
  document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });

  // Toast
  function toast(msg){
    var t = document.getElementById("toast");
    if(!t){ t = document.createElement("div"); t.id="toast"; t.className="toast"; document.body.appendChild(t); }
    t.innerHTML = '<svg viewBox="0 0 24 24"><path d="m5 12 5 5L20 6"/></svg><span>'+msg+'</span>';
    requestAnimationFrame(function(){ t.classList.add("show"); });
    clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove("show"); }, 2600);
  }
  window.twinkToast = toast;

  /* ===== Cart drawer (slide-in) ===== */
  function gmoney(c){ return "£" + (Math.round(c)/100).toFixed(2); } /* store is GBP */
  var cdBuilt = false;
  var CD_FREESHIP = Math.round(29.99 * 100); /* FREE DELIVERY THRESHOLD: change the 29.99 to your free-delivery £ amount. Keep it matching your Shopify Shipping settings. */

  var CD_CSS = ".cd-scrim{position:fixed;inset:0;background:rgba(30,22,10,.42);opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;z-index:2147483646}.cd-scrim.cd-open{opacity:1;visibility:visible}.cd-drawer{position:fixed;top:0;right:0;height:100%;height:100dvh;width:min(410px,92vw);background:var(--cream,#f4eee2);color:var(--ink,#211d18);box-shadow:-18px 0 50px rgba(40,30,15,.22);z-index:2147483647;transform:translateX(100%);transition:transform .34s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;overflow-y:auto;font-family:'Jost',sans-serif}.cd-drawer.cd-open{transform:translateX(0)}.cd-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px 16px;border-bottom:1px solid var(--line,#e3d9c8);position:sticky;top:0;background:var(--cream,#f4eee2);z-index:2}.cd-head h2{font-family:'Cormorant Garamond',serif;font-weight:600;font-size:28px;margin:0;line-height:1}.cd-close{background:none;border:none;cursor:pointer;color:var(--ink,#211d18);padding:4px;line-height:0;opacity:.7}.cd-close:hover{opacity:1}.cd-close svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.8}.cd-items{padding:4px 22px}.cd-empty{text-align:center;padding:60px 10px}.cd-empty p{opacity:.65;margin:0 0 18px}.cd-continue2{display:inline-block;background:var(--ink,#211d18);color:#fff;text-decoration:none;padding:12px 22px;border-radius:999px;font-size:13px;letter-spacing:.1em;text-transform:uppercase}.cd-line{display:flex;gap:13px;padding:16px 0;border-bottom:1px solid var(--line,#e3d9c8)}.cd-thumb{width:60px;height:60px;border-radius:8px;overflow:hidden;flex:none;background:var(--surface,#fbf7ef);display:block}.cd-thumb img{width:100%;height:100%;object-fit:cover}.cd-info{flex:1;min-width:0}.cd-name{font-family:'Cormorant Garamond',serif;font-weight:600;font-size:18px;color:var(--ink,#211d18);text-decoration:none;display:block;line-height:1.15}.cd-var{font-size:12px;opacity:.6;margin-top:2px}.cd-each{font-size:12px;opacity:.6;margin-top:3px}.cd-qty{display:inline-flex;align-items:center;border:1px solid var(--line,#e3d9c8);border-radius:999px;margin-top:9px}.cd-qty button{background:none;border:none;width:30px;height:30px;cursor:pointer;color:inherit;font-size:16px;line-height:1;font-family:inherit}.cd-qty span{min-width:24px;text-align:center;font-size:13px;font-weight:600}.cd-right{text-align:right;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-end}.cd-lp{font-weight:600;font-size:15px}.cd-rm{background:none;border:none;color:var(--ink,#211d18);opacity:.55;font-size:12px;cursor:pointer;text-decoration:underline;padding:0;font-family:inherit}.cd-nudges{padding:0}.cd-stockmsg{margin-top:6px;font-size:11.5px;font-weight:600;color:#b5781c}.cd-ship{margin:14px 22px 0;padding:12px 14px;background:#E3A42E;border:none;border-radius:12px;font-size:13px;color:#2a1d02;box-shadow:0 3px 10px rgba(201,138,20,.3)}.cd-ship-msg{margin-bottom:9px;line-height:1.35}.cd-ship-msg b{font-weight:700}.cd-bar{height:7px;background:rgba(0,0,0,.18);border-radius:999px;overflow:hidden}.cd-bar-fill{height:100%;background:#fff;border-radius:999px;transition:width .4s ease}.cd-nudge{display:flex;align-items:center;gap:10px;margin:10px 22px 0;padding:12px 15px;border:none;background:#C15B7C;border-radius:12px;font-size:13.5px;line-height:1.3;text-decoration:none;color:#fff;box-shadow:0 3px 10px rgba(193,91,124,.28)}.cd-nudge svg{width:21px;height:21px;flex:none;stroke:#fff;fill:none;stroke-width:1.9}.cd-nudge b{font-weight:700;color:#fff}.cd-nudge .cd-arrow{margin-left:auto;color:#fff;font-size:17px;opacity:.85}.cd-foot{padding:18px 22px 24px}.cd-saving{display:flex;justify-content:space-between;font-size:13px;font-weight:600;margin-bottom:6px}.cd-subtotal{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:3px}.cd-subtotal .l{font-family:'Cormorant Garamond',serif;font-size:22px;font-weight:600}.cd-subtotal .v{font-weight:600;font-size:20px}.cd-note{opacity:.55;font-size:12px;margin:0 0 14px}.cd-checkout{display:block;width:100%;background:var(--ink,#211d18);color:#fff;border:none;border-radius:999px;padding:15px;font-size:13px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;font-family:inherit;text-align:center;text-decoration:none}.cd-checkout:hover{opacity:.92}.cd-continue{display:block;width:100%;background:none;border:1px solid var(--ink,#211d18);color:var(--ink,#211d18);border-radius:999px;padding:14px;margin-top:10px;font-size:12px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;font-family:inherit;text-align:center}.cd-continue:hover{background:rgba(27,26,24,.06)}html.cd-lock{overflow:hidden}";

  var CD_HTML = '<div class="cd-scrim" id="cdScrim"></div><aside class="cd-drawer" id="cdDrawer" aria-label="Your basket"><div class="cd-head"><h2>Your Basket</h2><button class="cd-close" id="cdClose" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="cd-nudges" id="cdNudges"></div><div class="cd-items" id="cdItems"></div><div class="cd-foot" id="cdFoot" style="display:none"><div class="cd-saving" id="cdSaving" style="display:none"><span>Mix &amp; match saving</span><span id="cdSavingV"></span></div><div class="cd-subtotal"><span class="l">Subtotal</span><span class="v" id="cdSubtotal">£0.00</span></div><p class="cd-note">Shipping &amp; taxes calculated at checkout</p><a class="cd-checkout" href="/checkout">Checkout</a><button class="cd-continue" id="cdContinue" type="button">Continue shopping</button></div></aside>';

  function esc(s){ return (s||"").replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  function buildDrawer(){
    if(cdBuilt) return;
    cdBuilt = true;
    var style = document.createElement("style");
    style.textContent = CD_CSS;
    document.head.appendChild(style);
    var holder = document.createElement("div");
    holder.innerHTML = CD_HTML;
    while(holder.firstChild){ document.body.appendChild(holder.firstChild); }
    document.getElementById("cdScrim").addEventListener("click", closeCartDrawer);
    document.getElementById("cdClose").addEventListener("click", closeCartDrawer);
    document.getElementById("cdContinue").addEventListener("click", closeCartDrawer);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeCartDrawer(); });
    document.getElementById("cdItems").addEventListener("click", function(e){
      var c = e.target.closest("[data-cd-change]");
      if(!c) return;
      changeLine(c.getAttribute("data-key"), parseInt(c.getAttribute("data-cd-change"), 10));
    });
  }

  function openCartDrawer(){
    buildDrawer();
    document.getElementById("cdScrim").classList.add("cd-open");
    document.getElementById("cdDrawer").classList.add("cd-open");
    document.documentElement.classList.add("cd-lock");
    fetchCart();
  }
  function closeCartDrawer(){
    var s = document.getElementById("cdScrim"), d = document.getElementById("cdDrawer");
    if(s) s.classList.remove("cd-open");
    if(d) d.classList.remove("cd-open");
    document.documentElement.classList.remove("cd-lock");
  }
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  function fetchCart(){
    return fetch("/cart.js", { headers:{ "Accept":"application/json" }})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderDrawer(cart); return cart; })
      .catch(function(){});
  }
  function showStockMsg(key){
    var btn = document.querySelector('.cd-qty button[data-key="' + key + '"]');
    if(!btn) return;
    var wrap = btn.closest(".cd-qty");
    var span = wrap ? wrap.querySelector("span") : null;
    var n = span ? span.textContent.trim() : "";
    var info = btn.closest(".cd-info");
    if(!info) return;
    var old = info.querySelector(".cd-stockmsg");
    if(old) info.removeChild(old);
    var m = document.createElement("div");
    m.className = "cd-stockmsg";
    m.textContent = n ? ("Only " + n + " in stock") : "That's all the stock we have";
    info.appendChild(m);
    clearTimeout(info._sm);
    info._sm = setTimeout(function(){ if(m && m.parentNode) m.parentNode.removeChild(m); }, 4500);
  }
  function changeLine(key, qty){
    fetch("/cart/change.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json().then(function(d){ return { ok:r.ok, data:d }; }); })
      .then(function(res){
        if(res.ok && res.data && typeof res.data.item_count !== "undefined"){
          renderDrawer(res.data);
        } else {
          /* change rejected (e.g. not enough stock) — re-sync the real basket (never blank it), then show the limit next to that item's qty */
          fetchCart().then(function(){ showStockMsg(key); });
        }
      })
      .catch(function(){ fetchCart(); });
  }

  /* Free-delivery progress bar + "you're N away from the deal" nudge */
  function renderNudges(cart){
    var nz = document.getElementById("cdNudges");
    if(!nz) return;
    if(!cart.items || cart.item_count === 0){ nz.innerHTML = ""; return; }
    var nh = "";
    var tot = cart.total_price;
    if(tot >= CD_FREESHIP){
      nh += '<div class="cd-ship"><div class="cd-ship-msg">&#10003; <b>You\'ve unlocked FREE UK delivery!</b></div><div class="cd-bar"><div class="cd-bar-fill" style="width:100%"></div></div></div>';
    } else {
      var away = CD_FREESHIP - tot;
      var pct = Math.max(4, Math.round(tot / CD_FREESHIP * 100));
      nh += '<div class="cd-ship"><div class="cd-ship-msg">You\'re <b>' + gmoney(away) + '</b> away from <b>FREE UK delivery</b></div><div class="cd-bar"><div class="cd-bar-fill" style="width:' + pct + '%"></div></div></div>';
    }
    var deals = [
      { t:function(it){ return (it.product_title||it.title||"").indexOf("Snap Bar") > -1; }, q:4, label:"snap bar", deal:"4 for £10", url:"/collections/wax-melt-snap-bars" },
      { t:function(it){ return (it.product_title||it.title||"").indexOf("Essential Oil") > -1; }, q:3, label:"oil", deal:"3 for £10", url:"/collections/oils" },
      { t:function(it){ return it.product_type === "Carpet Freshener" || (it.product_title||"").indexOf("Carpet Freshener") > -1; }, q:3, label:"carpet freshener", deal:"3 for £20", url:"/collections/carpet-fresheners" },
      { t:function(it){ return it.product_type === "Car Diffuser" || (it.product_title||"").indexOf("Car Diffuser") > -1; }, q:2, label:"car diffuser", deal:"2 for £10", url:"/collections/car-diffusers" }
    ];
    deals.forEach(function(d){
      var c = 0;
      cart.items.forEach(function(it){ if(d.t(it)) c += it.quantity; });
      if(c > 0){
        var rem = d.q - (c % d.q);
        if(rem !== d.q){
          var pl = rem > 1 ? "s" : "";
          nh += '<a class="cd-nudge" href="' + d.url + '"><svg viewBox="0 0 24 24"><path d="M4 13 11 20a2 2 0 0 0 3 0l6-6a2 2 0 0 0 0-3L13 4H4z"/><circle cx="8" cy="8" r="1.2"/></svg><span>Add <b>' + rem + ' more ' + d.label + pl + '</b> for <b>' + d.deal + '</b></span><span class="cd-arrow">&#8594;</span></a>';
        }
      }
    });
    nz.innerHTML = nh;
  }

  function renderDrawer(cart){
    var countEl = document.getElementById("cartCount");
    if(countEl) countEl.textContent = cart.item_count;
    var items = document.getElementById("cdItems");
    var foot = document.getElementById("cdFoot");
    if(!items) return;
    renderNudges(cart);
    if(!cart.items || cart.item_count === 0){
      items.innerHTML = '<div class="cd-empty"><p>Your basket is empty.</p><a class="cd-continue2" href="/">Start shopping</a></div>';
      if(foot) foot.style.display = "none";
      return;
    }
    if(foot) foot.style.display = "block";
    var html = "";
    cart.items.forEach(function(it){
      var name = (it.product_title || it.title || "").split("(")[0].trim();
      var variant = (it.variant_title && it.variant_title.indexOf("Default") === -1) ? '<div class="cd-var">' + esc(it.variant_title) + '</div>' : "";
      var imgsrc = it.image ? (it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=120") : "";
      var img = imgsrc ? '<img src="' + imgsrc + '" alt="' + esc(name) + '">' : "";
      html += '<div class="cd-line"><a class="cd-thumb" href="' + it.url + '">' + img + '</a>'
        + '<div class="cd-info"><a class="cd-name" href="' + it.url + '">' + esc(name) + '</a>' + variant
        + '<div class="cd-each">' + gmoney(it.final_price) + ' each</div>'
        + '<div class="cd-qty"><button type="button" data-cd-change="' + (it.quantity - 1) + '" data-key="' + it.key + '" aria-label="Decrease">−</button>'
        + '<span>' + it.quantity + '</span>'
        + '<button type="button" data-cd-change="' + (it.quantity + 1) + '" data-key="' + it.key + '" aria-label="Increase">+</button></div></div>'
        + '<div class="cd-right"><div class="cd-lp">' + gmoney(it.final_line_price) + '</div>'
        + '<button type="button" class="cd-rm" data-cd-change="0" data-key="' + it.key + '">Remove</button></div></div>';
    });
    items.innerHTML = html;
    document.getElementById("cdSubtotal").textContent = gmoney(cart.total_price);
    var saving = (cart.original_total_price || cart.total_price) - cart.total_price;
    var sv = document.getElementById("cdSaving");
    if(saving > 0){ sv.style.display = "flex"; document.getElementById("cdSavingV").textContent = "−" + gmoney(saving); }
    else { sv.style.display = "none"; }
  }

  /* open the drawer from the header basket icon instead of jumping to /cart */
  var cartBtn = document.getElementById("cartBtn");
  if(cartBtn){ cartBtn.addEventListener("click", function(e){ e.preventDefault(); openCartDrawer(); }); }

  // Update cart count badge
  function refreshCartCount(){
    fetch("/cart.js", { headers:{ "Accept":"application/json" }})
      .then(function(r){ return r.json(); })
      .then(function(c){ var el = document.getElementById("cartCount"); if(el) el.textContent = c.item_count; })
      .catch(function(){});
  }

  // AJAX add-to-cart for any [data-add-form]
  document.addEventListener("submit", function(e){
    var form = e.target.closest("form[data-add-form]");
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : "";
    if(btn){ btn.disabled = true; btn.textContent = "Adding…"; }
    fetch("/cart/add.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify(serialize(form))
    }).then(function(r){ return r.json(); }).then(function(item){
      if(btn){ btn.disabled=false; btn.textContent=label; }
      openCartDrawer();
    }).catch(function(){
      if(btn){ btn.disabled=false; btn.textContent=label; }
      toast("Sorry — could not add to basket");
    });
  });
  function serialize(form){
    var id = form.querySelector('[name="id"]').value;
    var qEl = form.querySelector('[name="quantity"]');
    var quantity = parseInt((qEl && qEl.value) || 1, 10);
    var item = { id: id, quantity: quantity };
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function(el){
      if(el.disabled || !el.value) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if(m) props[m[1]] = el.value;
    });
    if(Object.keys(props).length) item.properties = props;
    return { items:[item] };
  }
})();
